import { Box, Text, VStack } from '@chakra-ui/react';
import { useImage } from 'lib/sanity';
import NextImage from 'next/image';
import type { HowToEarnPointsItem } from 'types/cms/blocks/HowToEarnPoints';

const MAX_WIDTH = '180px';

interface HowToEarnPointsCardProps extends HowToEarnPointsItem {
  isFirstCard?: boolean;
  isLastCard?: boolean;
}

export const HowToEarnPointsCard = ({
  title,
  image,
  points,
  isFirstCard = false,
  isLastCard = false,
}: HowToEarnPointsCardProps) => {
  const imageProps = useImage(image, { ratio: 5 / 4 });

  return (
    <VStack
      pl={isFirstCard ? 0 : { base: '3xs', md: 'sm' }}
      pr={isLastCard ? 0 : { base: '3xs', md: 'sm' }}
      gap={0}
      position="relative"
      flex={1}
      minWidth={0}
    >
      {imageProps && (
        <Box maxW={MAX_WIDTH} pb="3xs">
          <NextImage {...imageProps} />
        </Box>
      )}
      <Text size="body2" fontWeight="500" pb="4xs" textAlign="center">
        {title}
      </Text>
      <Text size="overline" color="blackAlpha.700">
        {points}
      </Text>
    </VStack>
  );
};
